module.exports = __webpack_public_path__ + "static/series_n-f6a54399d44505902e6898a85149a2af.png";